import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "erio_cookie_consent_v1";

/**
 * Non-blocking cookie/privacy notice. It NEVER gates access to the app — it is a
 * dismissible banner pinned to the bottom of the viewport. Choice is remembered
 * in localStorage so it shows at most once per browser. Purely informational:
 * the platform only uses essential cookies / local storage for sign-in.
 */
export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { setShow(!localStorage.getItem(KEY)); } catch { /* ignore */ }
  }, []);

  const close = (choice) => {
    try { localStorage.setItem(KEY, choice); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4" data-testid="cookie-consent">
      <div className="mx-auto flex max-w-3xl flex-col items-start gap-3 rounded-xl border border-black/10 bg-white p-4 shadow-lg sm:flex-row sm:items-center">
        <Cookie size={20} className="mt-0.5 shrink-0 text-ek-purple" />
        <p className="flex-1 text-sm text-ek-ink/70">
          We use only essential cookies and local storage to keep you signed in and remember preferences.
          See our{" "}
          <Link to="/privacy" className="font-medium text-ek-purple underline-offset-2 hover:underline" data-testid="cookie-privacy-link">
            Privacy Notice
          </Link>.
        </p>
        <div className="flex shrink-0 gap-2">
          <button onClick={() => close("essential")}
            className="rounded-lg border border-black/10 px-3.5 py-2 text-sm font-medium text-ek-ink/70 hover:bg-ek-canvas"
            data-testid="cookie-essential">
            Essential only
          </button>
          <button onClick={() => close("accepted")}
            className="ek-btn px-4 py-2 text-sm font-semibold"
            data-testid="cookie-accept">
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
